// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Button, ButtonProps } from 'antd';
import React, { ReactElement } from 'react';

import './THButton.scss';

interface THButtonProps extends ButtonProps {
    color?: 'amber' | 'red' | 'lime' | 'gray' | 'black' | 'yellow';
}

export const THButton = ({ className, color, type = 'default', ...props }: THButtonProps): ReactElement => (
    <Button
        className={classList('th-button', color, className, {
            'btn-default': type === 'default',
        })}
        type={type}
        {...props}
    />
);
